import React from "react";
import {connect} from "react-redux";
import { Link, withRouter } from 'react-router-dom';
import {PhoneOutlined, UserOutlined} from '@ant-design/icons';
//import jwtDecode from "jwt-decode";
import logo from '../../../../assets/img/logo-long.png'
import {Tooltip} from "antd";


const Top =(props)=> {
  return (
    <div id="navbar-top">
      <div style={{display: 'flex'}}>
        <Link to="/" className="logo-long" title="На головну">
          <img src={logo} alt="logo"/>
        </Link>
        <span className='current-page'>
           {props.history && props.history.location && props.history.location.pathname && props.history.location.pathname === "/" &&
             <p>Перевірка ознак нотаріуса</p>}
          {props.history && props.history.location && props.history.location.pathname && props.history.location.pathname === "/new-request" &&
            <p>Створення нового запиту</p>}
          {props.history && props.history.location && props.history.location.pathname && props.history.location.pathname === "/request-list" &&
            <p>Перелік поданих запитів</p>}
          {props.history && props.history.location && props.history.location.pathname && props.history.location.pathname === "/request-details" &&
            <p>Детальна інформація про запит</p>}
              </span>
      </div>
      <span className='person-name'>
               <Tooltip style={{width: "90%"}} title={
                 <div style={{textAlign:"center"}}>
                   <div>Телефон служби підтримки для нотаріусів: (044) 537-47-05</div>
                   <div>Режим роботи: Робочі дні 9:00-18:00</div>
                 </div>} placement="bottom">
                 <PhoneOutlined  style={{fontSize:"14px", color:"#6cc195"}}  className='icon' />
               </Tooltip>
              <UserOutlined className='icon' style={{fontSize:"14px"}} />
              <span className='person-name'>
                {`${props.user && props.user.data && props.user.data.idm && props.user.data.idm.fullName}`}
              </span>
            </span>
    </div>
  );
}


function mapStateToProps(state) {
  return{
    user: state.user
  }
}

const Topbar = withRouter(Top);

export default connect(mapStateToProps, null)(Topbar);
